export const content = `1. Head to the [Login page](https://login.joinuplift.co/auth/login).
2. Click **Forgot Password?**
3. Enter the email address you use to log in to BetterHelp then hit **Send Password Reset**.
4. We’ll send you an email with a link to reset your password. Be sure to check your spam folder if it's not in your inbox.

If you don’t get an email or you need more help, email us at [help@joinuplift.co](mailto:help@joinuplift.co).

## To change your password while logged into your account:

### On mobile

1. When you login to your account, use the ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXeXIJwP04KvM06u6WIx8nuaAoPCWQryeyiMM-hYrdALADSohtrLj-88TxvoJlIbRn-v70pQgmMDfThQOPkDhjpr1o65hbeCDqBdZ7ENVcmsAbBJ-fVkdg5ZuMhHnMtnn2AX5ehMmQ?key=X_qAGGjtHqUyfCz1NzAHxOO7) icon to open your navigation menu.
2. Select [**Account Settings**](/settings).
3. Scroll down to **Login**.
4. Where you see Password, select the > icon.
5. Enter your current password then enter what you want your new password to be. Confirm by typing it again.
6. Select **Save**.

### On desktop

1. When you login to your account, go to [**Account Settings**](/settings) from your sidebar navigation.
2. Scroll down to **Login**.
3. Where you see Password, select **Change**.
4. Enter your current password then enter what you want your new password to be. Confirm by typing it again.
5. Select **Save**.
`;
